<div
  class="modal-header"
  hsDraggable="modal-dialog"
  hsResizable="modal-content"
>
  <h4 class="modal-title">{{ title }} {{ accountId }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ng-container>
    <nf-table-layout
      class="cash-entry-table"
      hideTitle
      [isSectionTitle]="false"
      [gridOptions]="gridOptions"
      [data]="rowData"
      hideSearch
      [autoResizeGrid]="false"
      hideClearAll
    >
      <nf-table-properties [currentProperties]="propertiesTitle">
        <div class="properties-form-group">
          <label
            >Display Advanced Rows
            <nf-toggle
              [formControl]="displayAdvancedRows"
              (change)="toggleRows()"
              states="true"
            ></nf-toggle
          ></label>
          <label
            >Display Dynamic Rows
            <nf-toggle
              [formControl]="displayDynamicRows"
              (change)="toggleDynamicRows()"
              states="true"
            ></nf-toggle
          ></label>
        </div>
      </nf-table-properties>
    </nf-table-layout>
    <ngb-accordion
      *ngIf="
        (transactionMatchesCustody && transactionMatchesCustody.length > 1) ||
        (transactionMatchesTrading && transactionMatchesTrading.length > 1)
      "
      [destroyOnHide]="false"
    >
      <ngb-panel title="Matches">
        <ng-template ngbPanelContent>
          <p
            class="underlined-sub-heading"
            *ngIf="
              transactionMatchesCustody && transactionMatchesCustody.length > 1
            "
          >
            Custody
          </p>
          <hs-cash-entry-matches
            *ngIf="
              transactionMatchesCustody && transactionMatchesCustody.length > 1
            "
            [matches]="transactionMatchesCustody"
            [currencyList]="currencyList"
            [accountDisplayName]="accountNameAgg ?? accountName"
            (matchCellDoubleClick)="matchCellDoubleClick($event)"
          ></hs-cash-entry-matches>
          <p
            class="underlined-sub-heading"
            *ngIf="
              transactionMatchesTrading && transactionMatchesTrading.length > 1
            "
          >
            Trading
          </p>
          <hs-cash-entry-matches
            *ngIf="
              transactionMatchesTrading && transactionMatchesTrading.length > 1
            "
            [matches]="transactionMatchesTrading"
            [currencyList]="currencyList"
            [accountDisplayName]="accountName"
            (matchCellDoubleClick)="matchCellDoubleClick($event)"
          ></hs-cash-entry-matches>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
    <nf-form-control
      class="notes-control"
      label="Notes"
      [customErrorMessages]="getFieldValidatorFormatter('transactionNote')"
      [warnings]="noteWarning"
    >
      <textarea
        id="notesText"
        class="form-control"
        ngbAutofocus
        rows="3"
        [formControl]="note"
        (focus)="disableGridFocus()"
      ></textarea>
    </nf-form-control>

    <nf-form-control
      class="forbidden-control"
      label="Missing Permissions : "
      [customErrorMessages]="getFieldValidatorFormatter('forbiddenErrors')"
      [hidden]="!forbiddenErrors.errors"
    >
      <p id="forbiddenText" class="form-control">{{ forbiddenErrors.value }}</p>
    </nf-form-control>
  </ng-container>
  <hs-loader
    class="{{ !transactionLoaded || formSubmitting ? 'active' : '' }}"
    [loading]="!transactionLoaded || formSubmitting"
    [label]="loadingText"
    [errorLabel]="errorText"
    [showText]="!transactionLoaded || formSubmitting"
  ></hs-loader
  ><hs-dialog-error-details
    [errorHeader]="errorHeader"
    [errorDetails]="errorDetails"
  ></hs-dialog-error-details>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <nf-checkbox
      label="Clear Transaction"
      [formControl]="clearTransaction"
    ></nf-checkbox>
  </div>
  <div>
    <span *ngIf="isValidating" class="mdi mdi-loading">validating..</span>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      *ngIf="!transInput?.readOnly"
      nf-button="save"
      [disabled]="!isDataValid || this.isCellEditing"
      (click)="save()"
    ></button>
  </div>
</div>
